import React from 'react'
import ReactDatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

// CSS Modules, react-datepicker-cssmodules.css
// import 'react-datepicker/dist/react-datepicker-cssmodules.css';

type Props = {
    onChange: (date: Date[]) => void
    selected: Date
    label: string
    name: string
    minDate?: Date
    maxDate?: Date
    disabled?: boolean
}
export const DatePicker: React.FC<Props> = ({
  onChange,
  selected,
  label,
  name,
  minDate,
  maxDate,
  disabled
}) => {
  return (
    <label htmlFor={name}>
      {label}

      <ReactDatePicker
        selectsMultiple
        selected={selected}
        placeholderText="MM/DD/YYYY"
        onChange={onChange}
        value={selected?.toLocaleDateString()}
        name={name}
        isClearable
        id={name}
        minDate={minDate}
        maxDate={maxDate}
        disabled={disabled}
      />
    </label>
  )
}
